import React, {Component} from 'react';
import { Calendar, Views, momentLocalizer } from 'react-big-calendar';
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop'
import moment from 'moment';

import 'react-big-calendar/lib/sass/styles.scss';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.scss';
import './DwCalendar.scss';

const localizer = momentLocalizer(moment);

const DragAndDropCalendar = withDragAndDrop(Calendar)

class DwCalendar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dayLayoutAlgorithm: 'no-overlap',
      displayDragItemInCell: true
    }

    this.moveEvent = this.moveEvent.bind(this);
  }

  handleDragStart = event => {
    this.setState({
      draggedEvent: event
    })
  }

  dragFromOutsideItem = () => {
    return this.state.draggedEvent;
  }

  onDropFromOutside = ({ start, end, allDay }) => {
    const { draggedEvent } = this.state

    const event = {
      id: draggedEvent.id,
      title: draggedEvent.title,
      start,
      end,
      allDay: allDay,
    }

    this.setState({
      draggedEvent: null
    })
    this.moveEvent({ event, start, end })
  }

  moveEvent = ({ event, start, end, isAllDay: droppedOnAllDaySlot }) => {
    let allDay = event.allDay
    if (!event.allDay && droppedOnAllDaySlot) {
      allDay = true;
    }
    else if (event.allDay && !droppedOnAllDaySlot) {
      allDay = false;
    }

    this.props.updateEvent({
      ...event,
      title: event.originalTitle,
      start,
      end,
      allDay
    });
  }

  resizeEvent = ({ event, start, end }) => {
    this.props.updateEvent({
      ...event,
      title: event.orginalTitle,
      start,
      end
    });
  }

  handleSelect = ({ start, end }) => {
    this.props.showCreateModal(start, end);
  }

  displayEditModal(event) {
    this.props.showEditModal(event);
  }

  eventStyleGetter(event) {
    if(event.color) {
      return {
        style: {
          backgroundColor: event.color
        }
      }
    }
    if (event.type === 'court') {
      const style = {
        backgroundColor: '#7b111d',
      };

      return {
        style
      };
    }
    else if (event.type === 'vacation') {
      const style = {
        backgroundColor: '#019875',
      };

      return {
        style
      };
    }
    else if (event.type === 'on') {
      const style = {
        backgroundColor: '#67e1a6',
      };

      return {
        style
      };
    }
    else if (event.type === 'off') {
      const style = {
        backgroundColor: '#938fa0',
      };

      return {
        style
      };
    }
  }

  onRangeChange(date) {
    let startDate;
    let endDate;

    if (date.start) {
      startDate = date.start;
      endDate = date.end;
    }
    else {
      startDate = date[0];
      endDate = moment(date[date.length - 1]).endOf('day').toDate();
    }

    this.props.updateEventsForDateRange(moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD'));
  }

  getDefaultView() {
    if (this.props.defaultView === 'MONTH') {
      return Views.MONTH;
    }

    return Views.WEEK;
  }

  get events() {
    return this.props.events.map(e => {
      if(e.title && e.title.type === 'div') {
        return e;
      }
      return ({
        ...e,
        title: e.label ? <div><b>{e.label}</b> <span>{e.title ? e.title.replace('(no title)', '') : ''}</span>
        </div> : e.title ? e.title.replace('(no title)', '') : '',
        originalTitle: e.title
      })
    })
  }

  render() {
    return (
      <div className="dw-calendar">
        <DragAndDropCalendar
          selectable={this.props.canModify}
          resizable={this.props.canModify}
          draggableAccessor={() => this.props.canModify}
          localizer={localizer}
          showMultiDayTimes={true}
          views={['month', 'week', 'day']}
          events={this.events}
          onEventDrop={this.moveEvent}
          onEventResize={this.resizeEvent}
          defaultView={this.getDefaultView()}
          defaultDate={this.props.defaultDate}
          scrollToTime={new Date(new Date().setHours(7, 0, 0, 0))}
          dragFromOutsideItem={
            this.state.displayDragItemInCell ? this.dragFromOutsideItem : null
          }
          onDropFromOutside={this.onDropFromOutside}
          handleDragStart={this.handleDragStart}
          onSelectEvent={event => this.displayEditModal(event)}
          onSelectSlot={this.handleSelect}
          dayLayoutAlgorithm={this.state.dayLayoutAlgorithm}
          eventPropGetter={(event) => this.eventStyleGetter(event)}
          onRangeChange={(date) => this.onRangeChange(date)}
        />
      </div>
    );
  }
}

export default DwCalendar;
